module.exports = __webpack_public_path__ + "17f3ab7782d813050a19086f68298fe7.svg";